module.exports = __webpack_public_path__ + "img/icon_youtube.f6e7f9e5.svg";